'use client'

export const clickItem = (siteId?: string, target?: EventTarget, s?: {
  intellisuggestData?: string;
  intellisuggestSignature?: string;
  custom_url?: string;
}) => {
  if (typeof window === 'undefined' || !siteId) return;

  try {
    window.IntelliSuggest.clickItem(target, {
      siteId,
      intellisuggestData: s?.intellisuggestData ?? '',
      intellisuggestSignature: s?.intellisuggestSignature ?? '',
      href: s?.custom_url
    });
  } catch (err) {
    console.error('IntelliSuggest error:', err);
  }
};
